const SUBSCRIBE_URL = '/api/v1/subscription/subscribe'
const UNSUBSCRIBE_URL = '/api/v1/subscription/unsubscribe'

document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('[data-news-subscribe]')
  let fieldEmailValue = ''
  //const newsSubscribtionForm = document.getElementById('newsSubscribtionForm')
  //const isModalSubscribe = document.querySelector('[data-modal-subscribe]')
  //const isModalSubscribeErr = document.querySelector(
  //  '[data-modal-subscribe-error]',
  //)
  //const closeIcon = document.querySelectorAll('[data-modal-close-icon]')

  forms?.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault()

      const data = new FormData(form)

      const email = data.get('email')

      const actionValue = document
        .querySelector('[data-news-subscribe]')
        .getAttribute('action')

      if (email) {
        const response = await fetch(SUBSCRIBE_URL, {
          method: 'POST',
          body: JSON.stringify({ email: email }),
        })

        if (response.ok) {
          fieldEmailValue = email
        }

        if (actionValue) {
          window.location.href = actionValue + '?email=' + fieldEmailValue
        }
      } else {
        if (actionValue) {
          window.location.href = actionValue
        }
      }

      // if (email) {
      //   const response = await fetch(SUBSCRIBE_URL, {
      //     method: 'POST',
      //     body: JSON.stringify({ email: email }),
      //   })

      //   if (response.ok) {
      //     isModalSubscribe.classList.toggle('is-invisible')
      //     const descriptionEl = isModalSubscribe.querySelector(
      //       '.modal-info__text-description',
      //     )
      //     descriptionEl.innerHTML = descriptionEl.innerHTML.replace(
      //       '%email%',
      //       email,
      //     )

      //     closeIcon.forEach((item) => {
      //       if (item.dataset.closeSubscribe === '') item.focus()
      //     })
      //   } else {
      //     isModalSubscribeErr.classList.toggle('is-invisible')
      //     closeIcon.forEach((item) => {
      //       if (item.dataset.closeSubscribeError === '') item.focus()
      //     })
      //   }
      // }

      form.reset()
    })
  })
})

document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('newsSubscribtionForm')
  const fieldEmailInput = form?.querySelector('[data-input-email] input')
  const buttonSubscribe = form?.querySelector('[data-news-subscribtion-button]')
  const buttonUnSubscribe = form?.querySelector(
    '[data-news-unsubscribtion-button]',
  )
  const isModalSubscribe = document.querySelector('[data-modal-subscribe]')
  const isModalSubscribeErr = document.querySelector(
    '[data-modal-subscribe-error]',
  )
  const closeIcon = document.querySelectorAll('[data-modal-close-icon]')
  const checkboxLabel = document.querySelectorAll('[data-checkbox-label]')
  const checkboxLabelError = document.querySelector(
    '[data-checkbox-label-error]',
  )
  const fieldEmail = document.querySelector(`[data-input-email]`)
  const entityFields = Array.from(
    form?.querySelectorAll('input[data-entity]') ?? [],
  )
  const frequencyFields = Array.from(
    form?.querySelectorAll('input[data-frequency]') ?? [],
  )
  const incorrectEmailTextContent =
    fieldEmail?.previousElementSibling.textContent
  const regexpEmail = /^[A-Z0-9._%+-]+@[A-Z0-9-]+.+.[A-Z]{2,4}$/i

  const param = new URLSearchParams(window.location.search)

  if (fieldEmailInput && param.get('email')) {
    fieldEmailInput.value = window.location.href.split('=').pop()
  }

  fieldEmail?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      fieldEmail.focus()
    }
  })

  entityFields?.forEach((input, i, entities) => {
    input.addEventListener('change', () => {
      if (Array.from(entities).some((e) => e.checked)) {
        checkboxLabelError?.classList.add('is-hidden')
        checkboxLabel?.forEach((el) => {
          el.classList.remove('is-error')
        })
      }
    })
  })

  form
    ?.querySelector('[data-input-email] input')
    ?.addEventListener('input', () => {
      fieldEmail?.previousElementSibling.classList.add('is-hidden')
      fieldEmail?.classList.remove('is-error')
    })

  buttonUnSubscribe?.addEventListener('click', async (event) => {
    event.preventDefault()

    const formData = new FormData(form)
    const data = Object.fromEntries(formData)

    checkboxLabelError?.classList.add('is-hidden')
    checkboxLabel?.forEach((el) => {
      el.classList.remove('is-error')
    })

    if (!data.email || !data.email.match(regexpEmail)) {
      fieldEmail?.previousElementSibling.classList.remove('is-hidden')
      fieldEmail?.classList.add('is-error')
      fieldEmail.previousElementSibling.textContent = incorrectEmailTextContent

      return
    }
    const response = await fetch(UNSUBSCRIBE_URL, {
      method: 'POST',
      body: JSON.stringify({ email: data.email }),
    })

    if (response.ok) {
      form.reset()
    } else {
      const error = await response.json()
      if (error['email']) {
        fieldEmail?.previousElementSibling.classList.remove('is-hidden')
        fieldEmail?.classList.add('is-error')
        fieldEmail.previousElementSibling.textContent = error['email']
      } else {
        isModalSubscribeErr?.classList.toggle('is-invisible')
        closeIcon?.forEach((item) => {
          if (item.dataset.closeSubscribeError === '') item.focus()
        })
      }
    }
  })

  buttonSubscribe?.addEventListener('click', async (event) => {
    event.preventDefault()

    const formData = new FormData(form)
    const data = Object.fromEntries(formData)

    const emptySelectedEntity = entityFields.every((field) => !field.checked)
    const emailNotValid = !data.email || !data.email.match(regexpEmail)
    if (emptySelectedEntity) {
      checkboxLabelError?.classList.remove('is-hidden')
      checkboxLabel?.forEach((el) => {
        el.classList.add('is-error')
      })
    }

    if (emailNotValid) {
      fieldEmail?.previousElementSibling.classList.remove('is-hidden')
      fieldEmail?.classList.add('is-error')
      fieldEmail.previousElementSibling.textContent = incorrectEmailTextContent
    }
    if (emptySelectedEntity || emailNotValid) {
      return
    }

    const response = await fetch(SUBSCRIBE_URL, {
      method: 'POST',
      body: JSON.stringify({
        email: data.email,
        entities: entityFields
          ?.filter((entity) => entity.checked)
          .map((entity) => entity.name),
        frequency: frequencyFields
          ?.filter((frequency) => frequency.checked)
          .map((frequency) => frequency.id),
      }),
    })

    if (response.ok) {
      isModalSubscribe?.classList.toggle('is-invisible')
      const descriptionEl = isModalSubscribe.querySelector(
        '.modal-info__text-description',
      )
      descriptionEl.innerHTML = descriptionEl.innerHTML.replace(
        '%email%',
        data.email,
      )
      closeIcon?.forEach((item) => {
        if (item.dataset.closeSubscribe === '') item.focus()
      })
    } else {
      isModalSubscribeErr?.classList.toggle('is-invisible')
      closeIcon?.forEach((item) => {
        if (item.dataset.closeSubscribeError === '') item.focus()
      })
    }

    form.reset()
  })
})
